import { Box, Typography, useTheme } from '@mui/material';
import { Paper } from '@medtronic/pecc-react-component-library-js';
import { WarningAlt } from '@carbon/icons-react';
import PropTypes from 'prop-types';

const ErrorBoundaryFallback = ({ fallbackSx = {} }) => {
  const { palette } = useTheme();

  const { wrapperSx = {} } = fallbackSx;

  return (
    <Box
      component="div"
      sx={{
        minWidth: '145rem',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        m: '6.4rem 0',
        ...wrapperSx,
      }}
    >
      <Paper size="l" customHeight="50rem">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            columnGap: '12rem',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              gap: '1rem',
            }}
          >
            <Typography variant="headingMAlt">{'Oops! Something went wrong.'}</Typography>
            <Typography variant="body1">
              {"We're working to fix the issue. Please try refreshing the page or come back later."}
            </Typography>
            <Typography variant="body1">
              {'If the problem persists, contact our support team for assistance.'}
            </Typography>
          </Box>
          <WarningAlt size="25rem" color={palette.borderGray.main} />
        </Box>
      </Paper>
    </Box>
  );
};

ErrorBoundaryFallback.propTypes = {
  fallbackSx: PropTypes.shape({
    wrapperSx: PropTypes.object,
  }),
};

export default ErrorBoundaryFallback;
